export default __webpack_public_path__ + "static/agency-user5-3d447ba0f83fb6b64a97fee47d5f389d.png";